import type { FC } from 'react';
import React from 'react';

import type { TAgreement } from './models';

export const Agreement: FC<TAgreement> = ({
    Aligner,
    Control,
    Link,
    MarkdownContainer,
    Modal,
    On,
    Text,
    Toggle,
    textTermsUse,
}) => {
    return (
        <Aligner align="left" styler={{ marginTop: 24, marginBottom: 0 }}>
            <Text fontSize={14} fontWeight={4} kind="caption" lineHeight={18} tag="span">
                {'Отправляя заявку, я даю '}
                <Toggle>
                    <On>
                        <Modal isOpened title="Согласие на обработку персональных данных">
                            <MarkdownContainer htmlContent={textTermsUse} />
                        </Modal>
                    </On>
                    <Control>
                        <Link>
                            <Text
                                fontSize={14}
                                fontWeight={4}
                                kind="caption"
                                lineHeight={18}
                                tag="span"
                            >
                                согласие на обработку персональных данных
                            </Text>
                        </Link>
                    </Control>
                </Toggle>
            </Text>
        </Aligner>
    );
};
